'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (window, versions, local) {
  function getEditorRjsConfig(serviceTopology, editorModel) {
    var paths = (0, _getRjsConfig2.default)(versions, local, serviceTopology, editorModel);

    return {
      baseUrl: '',
      paths: paths,
      packages: ['platformIntegrationEditor', 'tpaIntegrationEditor'].map(function (packageName) {
        return {
          name: packageName,
          main: packageName,
          location: (0, _getIntegrationPath2.default)(packageName, window.editorBase)
        };
      }),
      bundles: {
        plugins: ['json', 'domReady', 'experiment']
      },
      shim: {
        color: { exports: 'Color' },
        lodash: { exports: '_' },
        keyboardMaster: { exports: 'key' },
        mediaFrame: { exports: 'MediaFrame', deps: ['zepto'] },
        aviary: { exports: 'featherEditor' },
        facebook: { exports: 'FB' },
        'jasmine-html': { deps: ['jasmine'] },
        'jasmine-boot': { deps: ['jasmine', 'jasmine-html'] },
        qaAutomation: { exports: 'initSanta' },
        ReactProxy: {
          deps: ['react'],
          exports: 'ReactProxy'
        }
      },
      map: {
        '*': {
          coreUtilsLib: 'santa-core-utils',
          imageClientApi: 'image-client-api',
          baseUILib: 'wix-base-ui',
          reactDOM: 'react-dom'
        }
      },
      jsx: {
        baseDefines: { lodash: '_', react: 'React' },
        fileExtension: '.html'
      },
      waitSeconds: 0
    };
  }

  return getEditorRjsConfig;
};

var _getIntegrationPath = require('../common/getIntegrationPath.js');

var _getIntegrationPath2 = _interopRequireDefault(_getIntegrationPath);

var _getRjsConfig = require('./get-rjs-config');

var _getRjsConfig2 = _interopRequireDefault(_getRjsConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=rjs-config.js.map